/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";

import { spacing } from "../../../../../../../global/emotion";
import type { CarouselApi } from "../../../../../../hooks/useCarousel";
import { useCarousel } from "../../../../../../hooks/useCarousel";
import type { CarouselProps } from "../../../../../blocks/layout/Carousel/Carousel.emotion";
import { Carousel } from "../../../../../blocks/layout/Carousel/Carousel.emotion";

const paddingBottomStyle: Interpolation = {
  paddingBottom: spacing.m,
};
const paddingTopStyle: Interpolation = {
  paddingTop: spacing.m,
};

export type SectionCarouselProps = CarouselProps & {
  size?: CarouselApi["size"];
};

export const SectionCarousel = ({
  children,
  size,
  ...props
}: SectionCarouselProps) => {
  const carouselApi = useCarousel({ size });

  return (
    <Carousel
      carouselApi={carouselApi}
      containerCSS={[paddingBottomStyle, paddingTopStyle]}
      {...props}
    >
      {children}
    </Carousel>
  );
};
